/**
 * Component to show the listing information for employees
 */
import * as React from 'react';
import { Table, Modal, Row, Tooltip, Icon } from 'antd';
import { IcommonProps } from '../common/props';
import '../../css/UserList.scss';
import util from '../common/utils';
import LocalStorage from '../../service/localstorage';
import { Link } from 'react-router-dom';
import strings from '../../eyeguide-localization/employee/strings.employee';
import { CustomSorter } from '../Sorter';

const storage = new  LocalStorage();
const VIEWS = {
    USERLIST: 'list',
    ADDUSER: '/employee/add',
    EDITUSER: '/employee/edit/',
    BULKUPLOAD: '/employee/upload'
};
/**
 * Property definition 
 */
interface IEmployeeListProps extends IcommonProps {
    users: Array<any>;
    notifyActiveClick: any;
    notifyResetClick: any;
    loading: boolean;
    emptyText: string;
    
}

/**
 * State definition
 */
interface IEmployeeListState {
    columnData: Array<any>;
    columns: Array<any>;
    pagination: any;
    loading: boolean;
    selectedRowKeys: Array<string>;    
    childColumnNames: any;
    loggedInUsername: string;
    modalVisible: any;
    recordClicked: any;
    emptyText: string;
}

/**
 * Listing component for displaying the users
 */
export default class EmployeeList extends React.Component<IEmployeeListProps, IEmployeeListState> {

    rowClass: string = 'rows';

    constructor(props: IEmployeeListProps) {
        super(props);
        this.state = {
            columnData: [],
            columns: [],
            pagination: {},
            loading: true,
            selectedRowKeys: [],
            childColumnNames: ['name', 'value'],
            loggedInUsername: '',
            modalVisible: false,
            recordClicked: [],
            emptyText: ''
        };        
    }

    componentDidMount() {
        this.componentWillReceiveProps(this.props);

    }

    componentWillReceiveProps(nextProps: any) {
        let columnData: any[] = this.buildData(nextProps.users);
        let columns = this.buildColumns(nextProps);
        const pagination = { ...this.state.pagination };
        pagination.total = nextProps.users.length;
        pagination.pageSize = 20 ;
        pagination.pageSizeOptions = ['20', '50', '75', '100'];
        pagination.showSizeChanger = true ;  
        pagination.showTotal = function (total: any) {
            return `Total ${total} Users`;
        };
        this.setState({
            loading: nextProps.loading,
            columnData: columnData,
            columns: columns,
            pagination,
            loggedInUsername: storage.getUsername(),
            emptyText: nextProps.users.length === 0 ? 'No data' : ''
        });
    }

    render() {
        console.log('UserList render called');
        return (     
            <div>      
            <Table 
                className="UserList"
                columns={this.state.columns} 
                dataSource={this.state.columnData} 
                pagination={this.state.pagination}
                rowKey={record => record.uid}
                loading={this.state.loading}
                rowClassName={(record, index) => 'rows'}
                expandRowByClick={true}
                locale={{ emptyText: this.state.emptyText }} 
            />
                        <Modal 
                            className="modal"
                            title={strings.lsConfirmPassResetTxt}
                            visible={this.state.modalVisible}
                            okText={strings.lsYesTxt}
                            onOk={() => this.setModalVisible(1)}
                            onCancel={() => this.setModalVisible(0)}
                            width={500}
                            bodyStyle={{padding: 0 }}
                            maskClosable={false}
                            closable={false}
                            destroyOnClose={true}
                        >   
                            <Row style={{padding: '19px'}}>
                                    {strings.lsConfirmPassResetInfoTxt + ' ' + 
                                                this.state.recordClicked.username + ' ?' }
                            </Row>
                        </Modal>
            </div>
        );            
    }

    /**
     * This function builds the data required by the Table component to display the Users
     * @param users Users array containing the users to be dispalyed
     */
    private buildData(users: Array<any>) {
        
        let columnData: Array<any> = [];
        users.forEach( (element: any) => {
            let data = {
                uid: element.uid,
                username: element.username,
                firstname: element.firstname,
                lastname: element.lastname,
                email: element.email,
                role: util.getRoleValue(element.roleid),
                active: element.active,
                setup: element.setup,
                signin: element.signin
            };
            columnData.push(data);
        }); 
        console.log('columnData', columnData);
        return columnData;
    }
  
    /**
     * This function returns the column setting for use with the Table component
     */
    private buildColumns(nextProps: any) {
        let user = this.state.loggedInUsername;
        let onHeaderCell = (column) => {
            return {
                onClick: () => {
                    this.setState({
                        columns: CustomSorter.cleanAndToggleSortOrder(this.state.columns, column.dataIndex)
                    });
                }
            };
        };
        let columns = [
          {
            title: strings.lsUsrNameTxt,
            dataIndex: 'username',
            sorter: (a: any, b: any) => a.username.localeCompare(b.username),
            className: 'rows',
            render: (text: any) => (
                <div
                    className={'clipped'}
                >
                {text}
                </div>),
            onHeaderCell
          },
          {
            title: strings.lsFNameTxt,
            dataIndex: 'firstname',
            sorter: (a: any, b: any) => a.firstname.localeCompare(b.firstname),
            className: 'rows',
            onHeaderCell
          },
          {
            title: strings.lsLNameTxt,
            dataIndex: 'lastname',
            sorter: (a: any, b: any) => a.lastname.localeCompare(b.lastname),
            className: 'rows',
            onHeaderCell
          },
           {
            title: strings.lsEmailTxt,
            dataIndex: 'email',
            sorter: (a: any, b: any) => a.email.localeCompare(b.email),
            className: 'rows',
            render: (text: any) => (
                <div
                    className={'clipped'}
                    style={{width: '100px'}}
                    title={text}
                >
                {text}
                </div>),
            onHeaderCell
          } ,
          {
            title: strings.lsRoleTxt,
            dataIndex: 'role',
            sorter: (a: any, b: any) => a.role.localeCompare(b.role),
            className: 'rows',
            render: (text: any) => (
                <div
                    className={'clipped'}
                    style={{width: '100px'}}
                    title={text}
                >
                {text}
                </div>),
            onHeaderCell
          } ,
          {
            title: 'Setup',
            dataIndex: 'setup',
            sorter: (a: any, b: any) => a.setup - b.setup,
            className: 'rows',
            render: (text: any) => {
                return text ? <Icon type="check" style={{color: 'green'}} />
                    : <Icon type="close" style={{color: 'red'}} />;
            },
            onHeaderCell
          } ,
          {
            title: 'Sign In',
            dataIndex: 'signin',
            sorter: (a: any, b: any) => a.signin - b.signin,
            className: 'rows',
            render: (text: any) => {
                return text ? <Icon type="check" style={{color: 'green'}} />
                    : <Icon type="close" style={{color: 'red'}} />;
            },
            onHeaderCell
          } ,
          {
            title: strings.lsActionTxt,
            dataIndex: 'uid',            
            render: (text: any, record: any) => (
                <div style={{wordBreak: 'normal'}}>
                    <Link 
                        // className="linkSpacing"
                        to={VIEWS.EDITUSER + record.uid}
                    >{record.username !==  user ? strings.lsEditTxt + ' | ' : strings.lsEditTxt}
                    </Link>
                    {record.username !==  user ? <a 
                        // className="linkSpacing"
                        onClick={ (e) => {    
                            console.log('e in onclick', record);  
                            e.stopPropagation();               
                            this.props.notifyActiveClick(record.active === 0 ? 1 : 0, record.uid, record); }
                        }
                    >{record.active === 0 ? strings.lsActivateTxt + ' | '
                                     : strings.lsDeActivateTxt + ' | '}
                    </a> : ''}
                    <Tooltip placement="rightBottom" title={strings.lsUsrPassCanResetTxt}>
                    <a 
                        onClick={ (e) => {    
                                console.log('e in onlcick', record);  
                                e.stopPropagation();       
                                this.setState({
                                    modalVisible: true,
                                    recordClicked: record
                                });    
                            }
                        }
                    >{strings.lsResetTxt}
                    </a>
                    </Tooltip>
                </div>
            )
          }
        ];
        return columns;
    }

    private confirmResetPwd() {
        let record = this.state.recordClicked;
        this.props.notifyResetClick(record.uid, record.firstname, record.username);
    }

    private setModalVisible(event: any) {
        console.log();
        if (event === 1) {
            this.confirmResetPwd();
        } 
        this.setState({
            modalVisible: false
        });
    }

}


// WEBPACK FOOTER //
// ./src/components/employee/EmployeeList.tsx